<template>
	<div style="padding: 20px 20px 20px 0;">
		<!-- 新增/修改弹框 -->
		<el-dialog :title="title" :visible.sync="show" width="34%" @close="close">
			<el-form :inline="true" :model="form" ref="form" label-width="100px">
				<el-form-item label="姓名" prop="name">
					<el-input v-model="form.name" placeholder="姓名"></el-input>
				</el-form-item>
				<el-form-item label="手机号" prop="phone">
					<el-input v-model="form.phone" placeholder="手机号"></el-input>
				</el-form-item>
				<el-form-item label="身份证号" prop="idCard">
					<el-input v-model="form.idCard" placeholder="身份证号"></el-input>
				</el-form-item>
				<el-form-item label="所属单位" prop="company">
					<el-input v-model="form.company" placeholder="所属单位"></el-input>
				</el-form-item>
				<el-form-item label="选择楼栋" prop="building">
					<el-select v-model="form.building" placeholder="请选择">
						<el-option label="A栋" value="A栋"></el-option>
						<el-option label="B栋" value="B栋"></el-option>
						<el-option label="C栋" value="C栋"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="当前状态" prop="status">
					<el-radio v-model="form.status" label="封禁"></el-radio>
					<el-radio v-model="form.status" label="正常"></el-radio>
				</el-form-item>
				<el-form-item label="权限有效日期" prop="time">
					<el-date-picker v-model="form.time" type="daterange" range-separator="至" start-placeholder="开始日期"
						end-placeholder="结束日期">
					</el-date-picker>
				</el-form-item>
				<div style="text-align: center;">
					<el-checkbox v-for="item in qx" v-model="form.menus" :label="item.id">{{ item.name }}</el-checkbox>
				</div>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="show = false">取 消</el-button>
				<el-button type="primary" @click="ok" :disabled="disable">确 定</el-button>
			</span>
		</el-dialog>
		<!-- tab页 -->
		<el-tabs v-model="selectForm.type" @tab-click="getAll()">
			<el-tab-pane label="员工" name="员工"></el-tab-pane>
			<el-tab-pane label="人才" name="人才"></el-tab-pane>
			<el-tab-pane label="访客" name="访客"></el-tab-pane>
			<el-tab-pane label="商户" name="商户"></el-tab-pane>
		</el-tabs>
		<!-- 搜索条件 -->
		<el-form :inline="true" :model="selectForm" ref="selectForm">
			<el-form-item label="卡号" prop="cardNo">
				<el-input v-model="selectForm.cardNo" placeholder="卡号"></el-input>
			</el-form-item>
			<el-form-item label="姓名" prop="name">
				<el-input v-model="selectForm.name" placeholder="姓名"></el-input>
			</el-form-item>
			<el-form-item label="手机号" prop="phone">
				<el-input v-model="selectForm.phone" placeholder="手机号"></el-input>
			</el-form-item>
			<!--el-form-item label="身份证" prop="idCard">
				<el-input v-model="selectForm.idCard" placeholder="身份证"></el-input>
			</el-form-item-->
			<el-form-item>
				<el-button type="primary" @click="getAll">查询</el-button>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="$refs.selectForm.resetFields(); getAll();">重置</el-button>
			</el-form-item>
			<el-form-item v-show="selectForm.type == '访客'">
				<el-button type="primary" @click="addRow">新增</el-button>
			</el-form-item>
		</el-form>
		<!-- 表格 -->

		<el-table :data="data" style="width: 100%" border>

			<el-table-column prop="cardNo" label="卡号" align="center"></el-table-column>
			<el-table-column prop="name" label="姓名" align="center"></el-table-column>
			<el-table-column prop="phone" label="手机号" align="center"></el-table-column>
			<!--el-table-column prop="idCard" label="身份证" align="center"></el-table-column-->
			<el-table-column prop="purview" label="权限范围" align="center"></el-table-column>
			<el-table-column v-if="selectForm.type == '商户'" prop="shopNum" label="商户号" align="center"></el-table-column>
			<el-table-column v-if="selectForm.type == '商户'" prop="shopName" label="商户名称"
				align="center"></el-table-column>
			<el-table-column v-if="selectForm.type == '商户'" prop="balance" label="绑定银行卡"
				align="center"></el-table-column>
			<el-table-column v-if="selectForm.type == '用户'" prop="company" label="所在单位"
				align="center"></el-table-column>
			<el-table-column v-if="selectForm.type == '物业'" prop="startTime" label="权限有效时间" align="center">
				<template slot-scope="{row}">{{ row.startTime ? row.startTime.split("T")[0] : "无" }} -
					{{ row.endTime ? row.endTime.split("T")[0] : "无" }}</template>
			</el-table-column>
			<el-table-column prop="balance" label="账户余额" align="center"></el-table-column>
			<el-table-column prop="status" label="当前状态" align="center"></el-table-column>

			<el-table-column label="操作" align="center">
				<template slot-scope="scope">
					<el-button type="text" v-if="selectForm.type != '物业' && selectForm.type != '访客'"
						@click="look(scope.row)">查看</el-button>
					<el-button type="text" @click="setRow(scope.row)">修改</el-button>
					<el-button type="text" @click="delRow(scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination @size-change="sizeChange" @current-change="currentChange" :page-sizes="[10, 20, 30, 40]"
			:page-size="selectForm.size" layout="total, sizes, prev, pager, next, jumper" :total="totalNum"
			style="margin-top: 10px;">
		</el-pagination>
	</div>
</template>

<script>
export default {
	data() {
		return {
			qx: [], //权限列表
			form: { //表单数据
				"name": "", //姓名
				"phone": "", //联系电话
				"idCard": "", //身份证号
				"company": "", //单位
				time: [],
				"startTime": "", //权限起始时间
				"endTime": "", //权限截止时间
				"menus": [], //权限范围id集合.
				"status": "封禁", //当前状态（封禁，正常）
				"building": "", //楼栋
				"purview": "", //权限范围  选择的权限文字拼接起来
				type: '访客'
			},
			oldForm: "", //表单备份数据
			data: [], //表格数据
			selectForm: { //查询条件
				"cardNo": "", //卡号
				"currentPage": 1,
				"idCard": "", //身份证号
				"name": "", //姓名
				"pageSize": 10,
				"phone": "", //联系电话
				"type": "物业" //类型（人才，商户，员工，客人）
			},
			totalNum: 0, //数据总数
			show: false, //控制弹窗
			title: "",
			disable: false, //节流
		}
	},
	methods: {
		ok() {
			this.disable = true;
			let url = "/api/oneCardSolution/updateOneCardSolution"
			if (this.title[0] == "新") {
				url = "/api/oneCardSolution/addOneCardSolution"
			}
			if (this.form.time.length) {
				this.form.endTime = new Date(this.form.time[1]).getTime()
				this.form.startTime = new Date(this.form.time[0]).getTime()
			} else {
				this.form.startTime = ""
				this.form.endTime = ""
			}
			this.form.purview = ""
			this.qx.forEach(item => {
				if (this.form.menus.indexOf(item.id) != -1) {
					this.form.purview += item.name + " "
				}
			})
			this.form.type = this.selectForm.type
			this.$http.post(url, this.form).then(res => {
				this.disable = false
				if (res.data.code == 0) {
					this.show = false;
					this.$message.success(`${this.title}成功`)
					this.getAll();
				} else {
					this.$message.error(`${res.data.message}`)
				}
			})
		},
		delRow(row) { //删除被点击
			this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http.get(`/api/oneCardSolution/deleteOneCardSolution?id=${row.id}`).then(res => {
					if (res.data.code == 0) {
						this.$message.success("删除成功")
						this.getAll();
					} else {
						this.$message.error("删除失败")
					}
				})
			}).catch(() => {
				this.$message.info('已取消删除');
			});
		},
		addRow() { //新增被点击
			this.getQx();
			this.form = JSON.parse(JSON.stringify(this.oldForm));
			this.title = "新增";
			this.show = true;
		},
		getQx() { //新增修改的时候获取权限
			this.$http.get("/api/oneCardSolution/getUserMenus").then(res => {
				this.qx = res.data.data
			})
		},
		look(row) {
			console.log("ddd");
			this.$router.push({
				name: '一卡通详情',
				params: {
					val: row
				}
			})
		},
		setRow(row) { //修改被点击
			this.getQx();
			this.form = JSON.parse(JSON.stringify(row))
			if (row.startTime && row.endTime) {
				this.form.time = [row.startTime, row.endTime]
			}
			this.title = "修改";
			this.show = true;
		},
		close() { //弹框关闭
			this.$refs.form.resetFields()
			this.form = JSON.parse(JSON.stringify(this.oldForm));
		},
		getAll() { //获取表格数据
			console.log(this.selectForm.type)
			this.$http.post(`/api/oneCardSolution/queryOneCardSolution`, this.selectForm).then(res => {
				console.log('this.data:',JSON.stringify(res.data))
				this.data = res.data.data.items;
				this.totalNum = res.data.data.totalNum;
			})
		},
		sizeChange(size) { //页大小被修改
			this.selectForm.size = size;
			this.getAll();
		},
		currentChange(page) { //当前页被修改
			this.selectForm.currentPage = page;
			this.getAll();
		}
	},
	created() {
		this.oldForm = JSON.parse(JSON.stringify(this.form))
		this.getAll();
	}
}
</script>

<style scoped="scoped">

</style>
